import React from 'react';
import styled from 'styled-components';
import { spacer12 } from '@spotify-internal/encore-web';
import { LanguageSelectionTrigger } from '../../../../features/src/i18n/components/LanguageSelection/Trigger';
import { LanguageSelectionOnboarding } from '../../../../features/src/i18n/components/LanguageSelection/Onboarding';
import { LanguageSelectionBoundary } from '../../../../features/src/i18n/components/LanguageSelection/Boundary';
import { useTracking } from '../../Tracking';

const MenuItem = styled.li`
  display: flex;
  align-self: center;
  margin: 0 ${spacer12};

  &:empty {
    display: none;
  }
`;

const CustomTrigger = styled(LanguageSelectionTrigger)`
  &,
  &:hover,
  &:focus,
  &:focus:after {
    color: currentColor;
    border-color: currentColor;
  }
`;

export const NavBarLanguageItem = () => {
  const { eventHandlerWithAction } = useTracking();
  return (
    <MenuItem
      onClick={eventHandlerWithAction(
        'Frodor - module - Language Picker',
        'click',
        'clicked-language-picker',
      )}
    >
      <LanguageSelectionBoundary fallback={null}>
        <LanguageSelectionOnboarding>
          <CustomTrigger buttonSize="sm" />
        </LanguageSelectionOnboarding>
      </LanguageSelectionBoundary>
    </MenuItem>
  );
};

type SideMenuLanguageSectionProps = {
  onButtonClick: (e: React.MouseEvent) => void;
};

export const SideMenuLanguageSection = ({
  onButtonClick,
}: SideMenuLanguageSectionProps) => {
  const { eventHandlerWithAction } = useTracking();
  return (
    <div
      className="encore-creator-dark-theme"
      onClick={eventHandlerWithAction(
        'Frodor - module - Side Menu Language Picker',
        'click',
        'clicked-language-picker',
      )}
    >
      <LanguageSelectionBoundary fallback={null}>
        <LanguageSelectionTrigger onClick={onButtonClick} />
      </LanguageSelectionBoundary>
    </div>
  );
};

type SideMenuLanguageOnboardingProps = {
  children: React.ReactNode;
};

export const SideMenuLanguageOnboarding = ({
  children,
}: SideMenuLanguageOnboardingProps) => {
  return (
    <LanguageSelectionBoundary fallback={children}>
      <LanguageSelectionOnboarding>{children}</LanguageSelectionOnboarding>
    </LanguageSelectionBoundary>
  );
};
